import { on as onEvent } from "common/utils/ui/event";
import { track } from "jiffy-analytics";
import initDetailsToggle from "components/jiffy/reviews-list-item/reviews-list-item";
import initRecaptchaModal from "components/jiffy/recaptcha-modal/recaptcha-modal";
// eslint-disable-next-line import/no-cycle
import initProductReviewsControls from "components/jiffy/product-reviews-controls/product-reviews-controls";
import "common/customer/redirect_to_help";
import "./reviews-list.scss";
import { api } from "jiffy-api";

const $getContainer = () => document.querySelector(".js-reviews-list-container");
const $getAnchor = () => document.querySelector(".js-reviews-anchor");
const $getPagination = () => document.querySelector(".jiffy-pagination");
const $getReviewSection = () => document.querySelector(".js-reviews-anchor");

const initTrackReviewScroll = () => {
  if (!$getReviewSection()) return;

  const $toObserve = $getPagination() || $getReviewSection();
  const intersectionObserver = new window.IntersectionObserver(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
    },
    {
      root: null,
      threshold: 0.1
    }
  );

  intersectionObserver.observe($toObserve);
};

export const loadReviews = async () => {
  const $container = $getContainer();
  if (!$container) return;

  const $spinner = document.querySelector(".js-reviews-list-spinner");
  $spinner.classList.toggle("hidden", false);

  const { productId, digitalAssetId } = $container.dataset;
  const { reviews } = await api.product.fetchProductReviews(
    { productId },
    { ...window.reviews, digital_asset_id: digitalAssetId }
  );

  $container.innerHTML = reviews;
  $spinner.classList.toggle("hidden", true);

  if (window.reviews?.page) {
    const originUri = new URL(window.location);
    const { searchParams } = originUri;
    searchParams.set("page", window.reviews.page);
    searchParams.delete("customizations[]");
    searchParams.delete("kind");
    searchParams.delete("sort");
    searchParams.delete("search");

    window.history.replaceState(null, null, `${originUri.pathname}?${searchParams.toString()}`);
  }

  initDetailsToggle();
  initTrackReviewScroll();
};

const initPagination = () => {
  const callback = event => {
    event.preventDefault();
    const $anchor = $getAnchor();
    const url = new URL(event.target.href || "", window.origin);
    const page = url.searchParams.get("page") || 1;
    window.reviews.page = page;
    loadReviews();

    $anchor.scrollIntoView({ behavior: "smooth" });
    track("product_detailed_reviews_page_nav");
  };

  onEvent("click", ".js-reviews-list-container .jiffy-pagination a", callback, true);
};

const loadDefaultParams = () => {
  if (window.reviews !== undefined) return;

  const url = new URL(window.location);
  window.reviews = {};
  ["page", "sort", "kind", "search"].forEach(reviewParam => {
    if (url.searchParams.get(reviewParam)) {
      window.reviews[reviewParam] = url.searchParams.get(reviewParam);
    }
  });

  if (window.reviews?.sort) {
    document.getElementById("results_sorting_options").value = window.reviews.sort;
  }

  if (window.reviews?.kind === "with_images") {
    document.querySelector('.js-product-w-reviews-img[data-name="kind"]').checked = true;
  }

  if (window.reviews?.search) {
    document.querySelector('[name="search"].product-reviews-controls__input').value =
      window.reviews.search;
  }

  if (url.searchParams.getAll("customizations[]").length > 0) {
    window.reviews.customizations = url.searchParams.getAll("customizations[]");
    window.reviews.customizations.forEach(customizationId => {
      document.getElementById(customizationId).checked = true;
    });
  }
};

export default async () => {
  loadDefaultParams();
  loadReviews();
  initPagination();
  initRecaptchaModal();
  initProductReviewsControls();
};
